// extracted by mini-css-extract-plugin
export default {"tableStyle":"Charts_tableStyle__0pwoV"};